import { IPlayerChannel } from "../../../interfaces/player/IPlayerUIState.ts";
import { LazyLoadImage } from "react-lazy-load-image-component";
import UtilsHelper from "../../../helpers/utilsHelper.ts";
import PlayerUIHelpers from "../../../helpers/playerUIHelpers.ts";
import { useAppDispatch, useAppSelector } from "../../../stores/store.ts";
import { playerUIActions } from "../playerUISlice.ts";
import { changeVideoAsync } from "../playerSlice.ts";
import DateHelper from "../../../helpers/dateHelper.ts";

interface IProps {
    channels: IPlayerChannel[];
}

const PlayerChannelListMobile = ({ channels }: IProps) => {
    const dispatch = useAppDispatch();
    const actualChannelIndex = useAppSelector(store => store.playerUI.actualChannelIndex);
    const handleClick = (channel: IPlayerChannel, channelIndex: number) => {
        dispatch(playerUIActions.setActualChannelIndex(channelIndex))
        dispatch(changeVideoAsync({ chId: channel.ch_id }));
    }
    return (
        <div className={"overflow-y-scroll px-4 space-y-2"}>
            {channels.map((channel, index) => {
                const actualEpgItem = PlayerUIHelpers.getActualEpgItem(channel);
                return <button
                    key={channel.ch_id}
                    className={`flex flex-col w-full ${index === 0 && "mt-4"} ${index === channels.length - 1 && "pb-4"}`}
                    onClick={() => { handleClick(channel, index) }}
                    disabled={actualChannelIndex === index}>
                    <div className={"flex items-center space-x-4 py-1 w-full"}>
                        <LazyLoadImage
                            alt=""
                            effect="opacity"
                            className="grow align-middle"
                            wrapperClassName={`flex items-center w-10 shrink-0`}
                            src={`${import.meta.env.VITE_MIX_CHANNEL_LOGO_URL}/${channel.logo}`}
                        />
                        <div className={"flex flex-col grow w-[calc(100%-56px)] items-start leading-4"}>
                            <p className={"font-base text-neutral-400"}>{channel.name}</p>
                            {actualEpgItem &&
                                <>
                                    <p className={"mt-1 text-sm truncate w-full text-left"}>{actualEpgItem.name}</p>
                                    <p className={"text-sm text-neutral-400"}>{`${DateHelper.GetHourAndMinuteFromUnixTimespanDate(actualEpgItem.start_timestamp)} - ${DateHelper.GetHourAndMinuteFromUnixTimespanDate(actualEpgItem.stop_timestamp)}`} </p>
                                    <div className="mt-1 flex-start flex h-1 w-full overflow-hidden bg-neutral-500 font-sans text-xs font-medium rounded-full">
                                        <div
                                            className={`flex h-full items-center justify-center overflow-hidden break-all bg-[#008DD2] bg-gradient-to-b from-sky-500 to-sky-900 text-white rounded-full`}
                                            style={{ width: UtilsHelper.calcProgressBar(actualEpgItem) }}
                                        ></div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    {index !== channels.length - 1 &&
                        <div className={"my-2 h-[1px] w-full bg-neutral-600"} />
                    }
                </button>
            })}
        </div>
    );
};

export default PlayerChannelListMobile;